import { useEffect, useState } from "react";
import { MapOfSubjectsView } from "./MapOfSubjectsView";
import { MapSectorsDataRFView } from "./MapSectorsDataRFView";
import { MapSettings, MapSettingsIndicatorType } from "../../../services/models/map_settings";
import styles from "./MapOfSubjectsView.module.css";
import sButtons from "../../../assets/styles/buttons.module.css";
import { MapSettingsColorModal } from "../map-settings/MapSettingsColorModal";

interface MapOfSubjectsWrapperProps {
  mapSettingsData: MapSettings;
  mapSectorsInfoData: any;
  indicatorType: MapSettingsIndicatorType | null;
  setIndicatorType: (indicatorType: MapSettingsIndicatorType) => void;
  title: string;
  isAdministrator: boolean;
  selectedYear: number | null;
}

export const MapOfSubjectsWrapper: React.FC<MapOfSubjectsWrapperProps> = ({
  mapSettingsData,
  mapSectorsInfoData,
  indicatorType,
  setIndicatorType,
  title,
  isAdministrator,
  selectedYear,
}) => {
  useEffect(() => {
    if (mapSettingsData) {
      setIndicatorType(mapSettingsData.indicatorType);
    }
  }, [mapSettingsData]);

  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <div className={styles.mapWrapper}>
        {mapSettingsData && mapSectorsInfoData && (
          <div className="position-relative">
            {indicatorType === "data_user" && (
              <button
                onClick={() => setModalShow(true)}
                className={`${sButtons.iconButton} ${sButtons.settingsButton} ${styles.colorSettingBtn}`}
              >
                Настройка цветов
              </button>
            )}
            {mapSettingsData && (
              <>
                <h1 className="mb-4">{title}</h1>
                {indicatorType === "data_rf" && (
                  <MapSectorsDataRFView
                    sectors={mapSectorsInfoData}
                    mapSettingsData={mapSettingsData}
                    isAdministrator={isAdministrator}
                    selectedYear={selectedYear}
                  />
                )}

                {indicatorType === "data_user" && (
                  <MapOfSubjectsView
                    sectors={mapSectorsInfoData}
                    mapSettingsData={mapSettingsData}
                    isAdministrator={isAdministrator}
                  />
                )}
              </>
            )}
          </div>
        )}
      </div>
      <MapSettingsColorModal mapSettingsData={mapSettingsData} show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};
